import * as Scroll from 'react-scroll'

let scroller = Scroll.scroller
export const scrollToElem = ({
    elemName,
    options = { duration: 500, smooth: true }
}) => {
    scroller.scrollTo(elemName, options)
}